(function() {
    const init = () => {
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (reducedMotion.matches || !('IntersectionObserver' in window) || !Element.prototype.animate) {
            return;
        }

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) {
                    return;
                }

                observer.unobserve(entry.target);
                if (reducedMotion.matches) {
                    return;
                }

                const offset = entry.target.matches('.bvjw-section-dnbs') ? -40 : 40;
                entry.target.animate([
                    { opacity: 0, transform: `translateY(${offset}px)` },
                    { opacity: 1, transform: 'translateY(0)' }
                ], { duration: 650, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' });
            });
        }, { threshold: 0.1 });

        document.querySelectorAll('.bvjw-section-dnbs, #doctorProfile .doctor-profile-home-grid > .col')
            .forEach((element) => observer.observe(element));
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
        init();
    }
})();